import React from 'react'

export  function ErrorLayout(props) {
    const {children} = props
  return (
    <div>ErrorLayout {children}</div>
  )
}
